import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { IAsidePromoModalProps } from './AsidePromoModal.types';

export const openAsidePromoModal = ({ onClose, ...data }: IAsidePromoModalProps) =>
    openPopupHelper({ popupName: popupNames.ASIDE_PROMO_MODAL, data, onClose });
